module.exports = `
<div>
	<div v-if="campaigns.length === 0" class="page-title">Coming Soon</div>
    <look-popup
	    v-if="dataisload"
	    :item="popupPost"
	    :isopen="popupIsOpen" 
	    v-on:close="closePopup"
	    v-on:addtocart="addCart"
	    :igimg="igImg"
    />
	<div v-if="campaigns.length !== 0" class="desktop show-pc">
	  <!--<div class="lookbook-menu">
	    <div v-for="(c, index) in campaigns" class="page-title">
	    	<a @click.prevnet="changeCampaign(index)" href="#">{{c.ShowTag.substr(1)}}</a>
	    </div>
	  </div>-->
	  <div class="lookbook-content" v-show="dataisload">
	    <div class="ComingSoon h1 font-style-1" v-if="posts.length === 0">Coming Soon</div>
	    <div v-if="posts.length !== 0" class="slide-line"></div>
	    <div v-if="posts.length !== 0" class="pb-5 position-relative" id="slide-lookbook">
			<div class="loading-mask lookbook" :class="{'active':!runLoading}"></div>
	      <!--<div class="slide-process">
	        <div class="process-bar"></div>
	      </div>-->
	      <div class="slide-wrap">
	        <div class="row row-slide">
	          <div class="hover-item col-md-3 slide-item" v-for="(item, index) in posts" :key="item.ID">
	          	<a class="position-relative d-block" @click.prevent="openPopup(index, item.ID, item.Cover)" href="#" :style="'padding-bottom: 100%; height:0; background:url(' + item.Cover + '); background-size: cover; background-position: center;'">
	              <div class="mask">
	                <div class="btn btn-shop" href="#">SHOP THIS LOOK</div>
	              </div>
	            </a>
	            </div>
	        </div>
	      </div>
	    </div>
	  </div>
	</div>
	<div v-if="campaigns.length !== 0" class="mobile show-mobile lookbook-content">
	  <div class="text-center h6 font-style-1 text-uppercase" style="padding-bottom: 16px;">Instagram @yuyu-active</div>
	  <div class="ComingSoon h3 font-style-1" v-if="posts.length === 0">Coming Soon</div>
	  <div class="row row-slide">
	    <div class="slide-item col-6" v-for="(item, index) in posts" :key="item.ID">
			<a class="position-relative d-block" @click.prevent="openPopup(index, item.ID)" href="#" :style="'padding-bottom: 100%; height:0; background:url(' + item.Cover + '); background-size: cover; background-position: center;'">

			</a>
		    <div v-if="item.showShopList" :id="'block'+item.ID" class="shopping-table item-detail-block py-5 active" :class="{'fixed-position': (index+1)%2===0}">	    
		      <shop-item :item="market" v-for="(market, index) in popupPost" :key="index"></shop-item>
			  <a @click.prevent="addCart($('.mobile .product-size-select option:selected'))" class="btn btn-primary btn-block" href="#">ADD TO CART</a>
		    </div>
	    </div>
	  </div>
	</div>
<div>
`;
